
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import {AuthContext} from "context/authProvider";



export default function StartPage() {
    const superUser = ['super_user']
    const {auth} = useContext(AuthContext);
    const location = useLocation();

    if (superUser.find(role => auth?.role?.includes(role))) {
        return(
            <Navigate to="/dashboard" state={{ from: location}}/>
        )
    }  else {
        return(
            <Navigate to="/unitsOverview" state={{ from: location}}/>
        )
    }


}